import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledAutoScrollContainerDiv = styled.div.withConfig({
  displayName: "AutoScrollButton__StyledAutoScrollContainerDiv"
})(["width:100%;text-align:center;"]);
export const AutoScrollButton = props => {
  const {
    autoScroll,
    onClickCallback
  } = props;
  return !autoScroll ? /*#__PURE__*/_jsx(StyledAutoScrollContainerDiv, {
    children: /*#__PURE__*/_jsx(Button, {
      "data-test-id": "autoScrollButton",
      use: "tertiary",
      size: "sm",
      onClick: onClickCallback,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "recordingReviewComponents.shared.autoScrollButton.autoScrollButton"
      })
    })
  }) : null;
};